(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulyv-essential-set"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ulyv-set')) {
customElements.define('ulyv-set', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.data = JSON.parse(this.querySelector('[data-set-products]').textContent);
    this.form = this.querySelector('form');
    this.color = this.querySelector('[name="set-color"]');
    this.hsize = this.querySelector('[name="hoodie-size"]');
    this.psize = this.querySelector('[name="pants-size"]');
    this.button = this.querySelector('[type="submit"]');
    this.error = this.querySelector('[role="alert"]');
    this.model = 'male';
    const requested = new URL(location.href).searchParams.get('color');
    const option = [...this.color.options].find(o => o.value.toLowerCase() === (requested || '').toLowerCase());
    if (option) this.color.value = option.value;
    this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency', currency:this.dataset.currency || 'CAD'}).format(cents / 100) + ' ' + (this.dataset.currency || 'CAD');
    this.form.addEventListener('change', () => this.update());
    this.querySelectorAll('[data-model]').forEach(button => button.addEventListener('click', () => { this.model = button.dataset.model; this.update(); }));
    this.form.addEventListener('submit', event => this.add(event));
    this.update();
  }
  update() {
    const color = this.color.value;
    this.hoodie = this.data.hoodie.find(v => v.option1 === color && v.option2 === this.hsize.value);
    this.pants = this.data.pants.find(v => v.option1 === color && v.option2 === this.psize.value);
    const selected = [this.hoodie, this.pants];
    this.button.disabled = !selected.every(v => v && v.available) || this.busy;
    this.button.textContent = this.button.disabled && !this.busy ? this.dataset.unavailableText : this.dataset.addText;
    if (selected.every(Boolean)) {
      const separate = selected.reduce((sum,v) => sum + v.price, 0);
      const total = selected.reduce((sum,v) => sum + Math.round(v.price * .9), 0);
      this.querySelector('[data-total]').textContent = this.money(total);
      this.querySelector('[data-separate]').textContent = this.money(separate);
      this.querySelector('[data-saving]').textContent = this.money(separate-total);
      ['hoodie','pants'].forEach(key => {
        const variant = this[key], image = this.querySelector('.ulyv-set__' + key + '-image');
        if (variant.featured_image?.src) { image.removeAttribute('srcset'); image.src = variant.featured_image.src + (variant.featured_image.src.includes('?') ? '&' : '?') + 'width=600'; image.alt = variant.featured_image.alt || color + ' ULYV ' + key; }
        this.querySelector('[data-' + key + '-link]').href = this.data[key + 'Url'] + '?variant=' + variant.id;
      });
    }
    const model = this.data.models[color]?.[this.model];
    if (model) { const image = this.querySelector('.ulyv-set__model'); image.removeAttribute('srcset'); image.src = model.url + '&width=1200'; image.alt = model.alt; }
    this.querySelectorAll('[data-model]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.model === this.model)));
    const url = new URL(location.href); url.searchParams.set('color',color); history.replaceState(null,'',url);
  }
  async add(event) {
    event.preventDefault();
    if (this.busy || this.button.disabled) return;
    this.busy = true; this.button.disabled = true; this.button.textContent = this.dataset.addingText; this.error.hidden = true;
    try {
      const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.hoodie.id,quantity:1},{id:this.pants.id,quantity:1}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.dataset.errorText);
      location.assign(this.dataset.cartUrl);
    } catch (error) {
      this.error.textContent = error.message || this.dataset.errorText; this.error.hidden = false; this.busy = false; this.update();
    }
  }
});
}

  } catch(e) { console.error(e); }
})();
})();
